<template lang="html">
    <nav class="admin-layout-nav">
        <router-link :to="{ name: 'app' }" class="back">
            <v-icon dark>keyboard_backspace</v-icon>
            Retour
        </router-link>

        <router-link :to="{ name: 'admin-users' }">
            <v-icon dark>mdi-account-settings-variant</v-icon>
            Utilisateurs
        </router-link>
        <router-link :to="{ name: 'admin-sync' }">
            <v-icon dark>cached</v-icon>
            Synchro
        </router-link>
    </nav>
</template>

<script>
    export default {

    }
</script>

<style lang="stylus" scoped>
    @import '../../assets/css/variables.styl';

    nav.admin-layout-nav {
        display: flex
        flex-direction: column
        height: $admin-nav-height
        width: $admin-nav-width
        background: $admin-nav-background
        z-index: 2
        font-family: 'Muli', sans-serif
        letter-spacing: -0.4px

        a {
            display: flex
            align-items: center
            height: $app-nav-width
            padding: 0 0 0 2rem
            color: #FFF
            font-size: 1.6rem
            text-decoration: none

            i.icon {
                margin: 0 1rem 0 0
                font-size: 2.5rem
            }

            &.router-link-active {
                background-color: $primary-light-color
            }

            &.back {
                margin-bottom: $app-header-height
                background-color: $primary-dark-color
                border: none
            }
        }

        & >>> ul.expansion-panel {
            box-shadow: none

            li.expansion-panel__container {
                background: none

                div.expansion-panel__header {
                    padding: 0 2rem !important
                    color: #fff
                    font-size: 1.6rem
                    font-weight: 700

                    i { color: #fff }
                }

                a {
                    font-size: 1.4rem

                    i.icon {
                        margin: 0 1rem 0 0
                        font-size: 2rem
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/layouts/admin/Nav.vue